export default __webpack_public_path__ + "static/media/secure-checkout-badge.2d9e40f6.png";